import { Form, FormLayout, Select, TextField } from "@shopify/polaris";
import { capitalize } from "lodash";
import React, { forwardRef, useCallback, useReducer } from "react";
import { arrInvalid, reducerFn } from "../../helper";
import { PLATFORMS, TEAM_ROLE } from "../../variable";
import { ComponentLabelPolaris } from "../shared/ComponentLabelPolaris";
import ChannelTeamMembers from "./channel-team-members";

const CHANNEL_OPTIONS = [
    { value: PLATFORMS.Amazon, label: capitalize(PLATFORMS.Amazon) },
    {
        value: PLATFORMS.Etsy,
        label: capitalize(PLATFORMS.Etsy),
        disabled: true,
    },
];

function ChannelTeamForm({ value }, ref) {
    const [state, setState] = useReducer(reducerFn, {
        name: "",
        channel: PLATFORMS.Amazon,
        memberIds: [],
        errors: {},
    });

    React.useEffect(() => {
        if (!value) return;

        const { name, channel, members } = value || {};
        setState({ name, channel, memberIds: getIds(members) });
    }, [value]);

    const handleSubmit = useCallback(() => {
        if (!state.name) {
            setState((p) => ({
                ...p,
                errors: { ...p.errors, name: "Name is required" },
            }));
            return;
        }

        const { errors, ...input } = state;
        return input;
    }, [state]);

    React.useImperativeHandle(ref, () => ({
        getState: handleSubmit,
    }));

    const handleStateChange = useCallback((value, id) => {
        const newState = { [id]: value };
        if (id === "name") {
            if (!value) {
                newState.errors = { name: "Name is required" };
            } else {
                newState.errors = {};
            }
        }

        setState(newState);
    }, []);

    return (
        <Form>
            <FormLayout>
                <div>
                    <ComponentLabelPolaris label="Name" required />
                    <TextField
                        id="name"
                        value={state.name}
                        placeholder="Enter Channel Team Name"
                        onChange={handleStateChange}
                        error={state.errors["name"]}
                    />
                </div>
                <Select
                    label="Channel"
                    id="channel"
                    options={CHANNEL_OPTIONS}
                    onChange={handleStateChange}
                    value={state.channel}
                />

                <ChannelTeamMembers
                    value={state.memberIds}
                    onChange={(value) => handleStateChange(value, "memberIds")}
                    roles={[
                        TEAM_ROLE.ChannelIdea,
                        TEAM_ROLE.ChannelSeller,
                        TEAM_ROLE.ChannelSupporter,
                        TEAM_ROLE.ChannelSupportLeader,
                    ]}
                />
            </FormLayout>
        </Form>
    );
}

function getIds(members) {
    if (arrInvalid(members)) return [];
    return Array.from(new Set(members.map((i) => i.id)));
}

export default forwardRef(ChannelTeamForm);
